export const componentName = 'BizParkConfig';
